import { useEffect, useLayoutEffect } from "react"
import { useCallback, useMemo, useRef } from "react"
import useUpdateEffect from "./useUpdateEffect"

export default function useAttribute<M extends any = object, R = any, D = undefined>(
    model: M | undefined, 
    fn: (model: M) => R,
    response?: D
): () => D extends undefined ? R | null : R | D {
    const old = useRef(model)
    const data = useRef<R | null>(null)

    if (old.current !== model) {
        data.current = null
        old.current = model
    }

    const attribute = useCallback(() => {
        if (!model)
            return response || null

        if (data.current !== null) 
            return data.current
        
        const result = fn(model)
        data.current = result
        return result
    }, [model])

    return attribute as () => D extends undefined ? R | null : R | D
}